import React from "react";
import { useTranslation } from "react-i18next";
import {
  ChartBarIcon,
  ClockIcon,
  TrophyIcon,
  ArrowTrendingUpIcon,
} from "@heroicons/react/24/outline";

const Analytics = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-white">
          {t("analytics.title")}
        </h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-dark-800 border border-dark-700 rounded-lg p-6">
          <div className="flex items-center">
            <div className="bg-blue-600 p-3 rounded-lg">
              <ChartBarIcon className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-dark-300">
                {t("analytics.stats.totalTasks")}
              </p>
              <p className="text-2xl font-bold text-white">156</p>
            </div>
          </div>
        </div>

        <div className="bg-dark-800 border border-dark-700 rounded-lg p-6">
          <div className="flex items-center">
            <div className="bg-green-600 p-3 rounded-lg">
              <TrophyIcon className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-dark-300">
                {t("analytics.stats.completed")}
              </p>
              <p className="text-2xl font-bold text-white">89</p>
            </div>
          </div>
        </div>

        <div className="bg-dark-800 border border-dark-700 rounded-lg p-6">
          <div className="flex items-center">
            <div className="bg-yellow-600 p-3 rounded-lg">
              <ClockIcon className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-dark-300">
                {t("analytics.stats.avgTime")}
              </p>
              <p className="text-2xl font-bold text-white">2.5h</p>
            </div>
          </div>
        </div>

        <div className="bg-dark-800 border border-dark-700 rounded-lg p-6">
          <div className="flex items-center">
            <div className="bg-purple-600 p-3 rounded-lg">
              <ArrowTrendingUpIcon className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-dark-300">
                {t("analytics.stats.efficiency")}
              </p>
              <p className="text-2xl font-bold text-white">94%</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-dark-800 border border-dark-700 rounded-lg p-6">
        <h2 className="text-lg font-semibold text-white mb-4">
          {t("analytics.dashboard.title")}
        </h2>
        <div className="text-center py-12">
          <ChartBarIcon className="h-16 w-16 text-dark-400 mx-auto mb-4" />
          <p className="text-dark-300">{t("analytics.dashboard.comingSoon")}</p>
          <p className="text-sm text-dark-400 mt-2">
            {t("analytics.dashboard.description")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
